import { Component, Input } from '@angular/core';
import { DetailsUsers } from '../../resource/resources';

@Component({
  selector: 'last-update',
  templateUrl: './last-update.component.html',
  styleUrls: ['./last-update.component.scss']
})
export class LastUpdateComponent {
  @Input() detailUsers?: DetailsUsers = {};
}
